import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, createVNode as _createVNode, renderSlot as _renderSlot, resolveComponent as _resolveComponent, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-6d8066b0")

_pushScopeId("data-v-6d8066b0")
const _hoisted_1 = { class: "relative w-full m-0 overflow-auto h-full table-modal-area" }
const _hoisted_2 = { class: "w-full m-0 table-fixed border-separate" }
const _hoisted_3 = {
  key: 0,
  width: "9",
  height: "12",
  viewBox: "0 0 9 12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Skeleton = _resolveComponent("Skeleton")!
  const _component_PaginationV3 = _resolveComponent("PaginationV3")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("table", _hoisted_2, [
        _createVNode("thead", null, [
          _createVNode("tr", null, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.column, (col, index) => {
              return (_openBlock(), _createBlock("th", {
                key: `head-${col.name}-${index}`,
                style: { ...col.style }
              }, [
                (!col.orderBy)
                  ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                      _createTextVNode(_toDisplayString(col.name), 1)
                    ], 64))
                  : (_openBlock(), _createBlock("button", {
                      key: 1,
                      class: "flex items-center gap-2",
                      onClick: () => _ctx.onSort(col.orderBy)
                    }, [
                      _createVNode("div", null, _toDisplayString(col.name), 1),
                      (!_ctx.loading)
                        ? (_openBlock(), _createBlock("svg", _hoisted_3, [
                            _createVNode("path", {
                              d: "M6.91074 4.75592C7.23618 5.08136 7.76382 5.08136 8.08926 4.75592C8.41469 4.43049 8.41469 3.90285 8.08926 3.57741L4.75592 0.244078C4.43049 -0.0813592 3.90285 -0.0813593 3.57741 0.244078L0.244078 3.57741C-0.0813593 3.90285 -0.0813594 4.43048 0.244078 4.75592C0.569515 5.08136 1.09715 5.08136 1.42259 4.75592L4.16667 2.01184L6.91074 4.75592Z",
                              fill: 
                      col.orderBy === _ctx.orderBy && _ctx.sortBy === 'ASC'
                        ? '#B82025'
                        : '#A7A8AA'
                    
                            }, null, 8, ["fill"]),
                            _createVNode("path", {
                              d: "M1.42259 6.91074C1.09715 6.58531 0.569515 6.58531 0.244078 6.91074C-0.0813588 7.23618 -0.0813588 7.76382 0.244078 8.08926L3.57741 11.4226C3.90285 11.748 4.43049 11.748 4.75592 11.4226L8.08926 8.08926C8.41469 7.76382 8.41469 7.23618 8.08926 6.91075C7.76382 6.58531 7.23618 6.58531 6.91075 6.91075L4.16667 9.65482L1.42259 6.91074Z",
                              fill: 
                      col.orderBy === _ctx.orderBy && _ctx.sortBy === 'DESC'
                        ? '#B82025'
                        : '#A7A8AA'
                    
                            }, null, 8, ["fill"])
                          ]))
                        : _createCommentVNode("", true)
                    ], 8, ["onClick"]))
              ], 4))
            }), 128))
          ])
        ]),
        (!_ctx.loading)
          ? (_openBlock(), _createBlock("tbody", _hoisted_4, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.data, (item, i) => {
                return (_openBlock(), _createBlock("tr", {
                  key: `row-${i}`
                }, [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.column, (col, idx) => {
                    return (_openBlock(), _createBlock("td", {
                      key: `col-${col.name}-${idx}`,
                      class: ["col", col.class ? col.class : ''],
                      style: { ...col.style }
                    }, [
                      (col.slotName)
                        ? _renderSlot(_ctx.$slots, col.slotName, {
                            key: 0,
                            data: item,
                            index: i
                          }, undefined, true)
                        : _createCommentVNode("", true),
                      (col.render)
                        ? (_openBlock(), _createBlock("div", {
                            key: 1,
                            innerHTML: col.render(item, i)
                          }, null, 8, ["innerHTML"]))
                        : _createCommentVNode("", true)
                    ], 6))
                  }), 128))
                ]))
              }), 128))
            ]))
          : (_openBlock(), _createBlock("tbody", _hoisted_5, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(Array.from({ length: _ctx.pagination.limit }), (_item, i) => {
                return (_openBlock(), _createBlock("tr", {
                  key: `row-${i}`
                }, [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.column, (col, idx) => {
                    return (_openBlock(), _createBlock("td", {
                      key: `col-${col.name}-${idx}`,
                      class: ["col", col.class ? col.class : ''],
                      style: { ...col.style }
                    }, [
                      _createVNode(_component_Skeleton)
                    ], 6))
                  }), 128))
                ]))
              }), 128))
            ]))
      ])
    ]),
    (!_ctx.loading)
      ? (_openBlock(), _createBlock(_component_PaginationV3, {
          key: 0,
          renderedData: _ctx.data.length,
          pagination: _ctx.pagination,
          "onUpdate:pagination": _cache[1] || (_cache[1] = ($event: any) => (_ctx.pagination = $event)),
          onSetPage: _ctx.setPage
        }, null, 8, ["renderedData", "pagination", "onSetPage"]))
      : _createCommentVNode("", true)
  ], 64))
})